import { keyframes } from '@mui/system'
import Box from '@mui/material/Box'

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  70% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
`

export function PageLoader() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Box
        component="img"
        src="/images/fitup-icon.svg"
        alt="Loading"
        sx={{
          width: 100,
          height: 100,
          borderRadius: '50%',
          animation: `${pulse} 2s infinite`,
        }}
      />
    </Box>
  )
}
